import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true, // Allows usage in standalone components
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, searchInput: string): string {
    if (!searchInput || !text) return text; // If no search term, return plain text

    const words = searchInput
      .split(/\s+/) // Split search terms by spaces
      .map((word) => word.trim())
      .filter((word) => word.length > 0); // Remove empty entries

    if (words.length === 0) return text; // If no valid words, return plain text

    // Create regex for all words (case-insensitive)
    const regex = new RegExp(`(${words.join('|')})`, 'gi');

    // Replace words with highlighted span
    return text.replace(regex, `<span class="highlight">$1</span>`);
  }
}
